<template>
  <div class="container-xl mt-3">
    <div class="row row-cards">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <!-- Page title -->
        <div class="page-header d-print-none mb-2">
          <div class="row align-items-center">
            <div class="col">
              <h2 class="page-title">資產</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">
                  資產列表 - 本次預計撥款總額 - 每日凌晨五點更新
                </h3>
              </div>
              <div class="card-body">
                <div
                  class="row mb-1 mt-1 g-2 align-items-center"
                  v-for="(asset, index) in assets"
                  :key="index"
                >
                  <div class="col-md-2">
                    <span
                      v-if="asset.currency === 'USDT'"
                      class="avatar"
                      :style="{
                        background: '#fff center/cover',
                        backgroundImage:
                          'url(\'' +
                          require('../assets/images/usdt.png') +
                          '\')',
                      }"
                    ></span>
                    <span
                      v-if="asset.currency === 'USDC'"
                      class="avatar"
                      :style="{
                        background: '#fff center/cover',
                        backgroundImage:
                          'url(\'' +
                          require('../assets/images/usdc.png') +
                          '\')',
                      }"
                    ></span>
                  </div>
                  <div class="col-md-3">
                    <h3 class="mb-0">{{ asset.currency }} 數量</h3>
                  </div>
                  <div class="col-md-7">
                    <h3 class="mb-0">
                      {{
                        asset.amount.substring(
                          0,
                          asset.amount.indexOf(".") + 3
                        )
                      }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">撥款記錄</h3>
              </div>
              <div class="card-body">
                <table class="table table-vcenter card-table table-striped">
                  <thead>
                    <tr>
                      <th>幣種</th>
                      <th>金額</th>
                      <th>日期</th>
                      <th class="w-1"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(record, index) in withdrawHistory"
                      :key="index"
                    >
                      <td>{{ record.currency }}</td>
                      <td style="word-break: break-all; word-wrap: break-all">
                        {{
                          record.amount.substring(
                            0,
                            record.amount.indexOf(".") + 3
                          )
                        }}
                      </td>
                      <td>
                        {{
                          record.createdAt
                            | moment(
                              "timezone",
                              "Asia/Taipei",
                              "YYYY-MM-DD hh:mm:ss"
                            )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">設定</h3>
              </div>
              <div class="card-body">
                <div
                  :class="
                    alertStatus === 'success'
                      ? 'alert alert-success'
                      : 'alert alert-danger'
                  "
                  v-show="alertStatus !== ''"
                  role="alert"
                >
                  {{ alertMsg }}
                </div>
                <div class="row mb-1 mt-1 g-2 align-items-center">
                  <div class="col-md-6">收款協議設定</div>
                  <div class="col-md-6">
                    <router-link
                      to="paymentProtocolSetting"
                      class="btn btn-outline-info w-100"
                      >設定
                    </router-link>
                  </div>
                </div>
                <div class="row mb-1 mt-1 g-2 align-items-center">
                  <div class="col-md-6">結算錢包地址設定</div>
                  <div class="col-md-6">
                    <router-link
                      to="walletAddressesSetting"
                      class="btn btn-outline-info w-100"
                      >設定
                    </router-link>
                  </div>
                </div>
                <div class="row mb-1 mt-1 g-2 align-items-center">
                  <div class="col-md-6">每週自動撥款日期</div>
                  <div class="col-md-6">
                    <router-link
                      to="withdrawSetting"
                      class="btn btn-outline-info w-100"
                      >設定
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      profileInfo: {
        phoneVerification: false,
        emailVerification: false,
        KYCVerificationStatus: false,
        KYCBankingVerificationStatus: false,
        email: "",
      },
      token: "",
      alertMsg: "",
      alertStatus: "",
      assets: [],
      withdrawHistory: [],
    };
  },
  methods: {
    async getAssets() {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/assets`;
      try {
        const res = await this.$http.get(api, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.assets = res.data.data;
      } catch (err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
      }
    },
    async getWithdrawHistory(currency) {
      const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/settlementHistory/${currency}`;
      try {
        const res = await this.$http.get(api, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.withdrawHistory = res.data.data;
      } catch (err) {
        if (err.response.status === 401) {
          this.$parent.$parent.isExpired = true;
          this.$parent.$parent.checkSessionExpired()
        }
      }
    },
  },
  created() {
    this.token = Cookies.get("USD2PayToken");
    this.getAssets();
    this.getWithdrawHistory("USDT");
  },
};
</script>
